/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const state = {
  user: {
    id: null,
    info: {
      username: null,
      email: null,
      full_name: null,
      first_name: null,
      last_name: null
    },
  }
}


export default state
